import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MVMSpinnerBtnComponent } from './mvm-spinner-btn.component';
@NgModule({
    declarations: [
        MVMSpinnerBtnComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        MVMSpinnerBtnComponent
    ]
})
export class MVMSpinnerBtnModule { }
